<template lang="html">
	<div class="patrimonial-form">
    <form class="form-ui landscape-patrimonial-ui" novalidate>
      <div class="top">
        <p class="msg-success" v-if="isAnonymous && !showAnonymousCtaModal">
          <span class="icon-check"></span> Bravo ! vous venez de finaliser votre paysage patrimonial, vous pouvez maintenant le télécharger.
        </p>
        <br>
        <template v-if="!isAnonymous || !showAnonymousCtaModal">
          <div class="label solo bold">
            Je confirme que les informations renseignées sont exactes
          </div>
          <div class="ctn-toggle row">
            <custom-toggle :value="isSign" @change="isSign=$event" />
          </div>
        </template>
      </div>
      <div class="bottom" v-if="isAdvisor">
        En cliquant sur "Demande de signature électronique" un e-mail sera envoyé au client lui permettant de signer électroniquement le paysage patrimonial que vous avez completé
      </div>
      <div class="bottom" v-if="!isAdvisor && !isAnonymous">
        En cliquant sur “Signer” vous allez être redirigé vers notre module de signature électronique afin de valider la saisie de votre paysage patrimonial.
      </div>

      <div v-if="isAnonymous && showAnonymousCtaModal" class="column text-center">
        <h1 class="title">
          Complétez votre inscription pour bénéficier<br/>
          de toutes les fonctionnalités Patrimoffice
        </h1>
        <div class="subtitle text-center">
          Ainsi que d'un essai gratuit d'un mois
        </div>
        <router-link class="btn btn-red" :to="{ name: 'AnonymousUpgrade' }">
          Compléter mon inscription <i class="icon-arrow-full-right"></i>
        </router-link>
      </div>

			<transition name="bounce">
				<div class="alert alert-warning" role="alert" v-if="signaturePopupBlocked">
					<div class="alert-wrapper row">
						<span class="icon icon-alert"></span>
						<div class="alert-content column">
							<p>
								Votre navigateur a pu bloquer la fenêtre d’accès à la signature.
								<br>
								C'est courant, cliquez sur le bouton à droite pour accéder au service de signature.
							</p>
						</div>
						<div class="btn btn-red" @click="showUnlockPopupTuto = true">
							Voir les instructions
						</div>
					</div>
				</div>
			</transition>

			<unlock-signature-popup-tutorial
				v-if="showUnlockPopupTuto"
				@close="showUnlockPopupTuto = false"/>
		</form>
	</div>
</template>

<script>
import CustomToggle from '@/common/components/Form/CustomToggle'
import {mapGetters} from 'vuex'
import UnlockSignaturePopupTutorial from '@/common/components/UnlockSignaturePopupTutorial'
export default {
	name: 'Signature',
	components: {
		UnlockSignaturePopupTutorial,
		CustomToggle
	},
	methods: {
		validate () {
			return new Promise((resolve, reject) => { if (this.isSign) { resolve(true) } else { reject(new Error('Vous devez signer le paysage patrimonial')) } })
		}
	},
	data () {
		return {
			isSign: false,
			showAnonymousCtaModal: false,
			signaturePopupBlocked: false,
			showUnlockPopupTuto: false,
			isAdvisor: (process.env.SITE === 'cgpi')
		}
	},
	mounted () {
		this.isSign = !this.isAnonymous
		this.showAnonymousCtaModal = this.isForceCompleteProfile
		this.$root.$on('show-anonymous-cta-modal', (value) => {
			this.showAnonymousCtaModal = value
		})
		this.$root.$on('signature-popup-blocked', () => {
			this.signaturePopupBlocked = true
		})
	},
	watch: {
		isSign (value) {
			this.$root.$emit('signature-confirm-info', value)
		}
	},
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous',
			isForceCompleteProfile: 'isForceCompleteProfile'
		})
	}
}
</script>

<style lang="scss" scoped>
	.bottom {
		margin-top: 250px;
		font-size: 0.8rem;
	}

  .view .title {
    margin-top: 70px;
    width: 90% !important;
  }

  .msg-success {
    font-family: "Lato Bold";

    span {
      margin-right: 0.2rem;
      color: #af9376;
    }
  }

	.bounce-enter-active {
		animation: bounce-in .5s;
	}
	.bounce-leave-active {
		animation: bounce-in .5s reverse;
	}
	@keyframes bounce-in {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.7);
		}
		100% {
			transform: scale(1);
		}
	}

	.alert-content {
		width: 60%;
	}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Signature.vue